import React from "react";
import { useState } from "react";
import Pagination from "../Pagination";
import { useTranslation } from "react-i18next";
import Global, { formatDate } from "../../util/Global";
import NotFound from "../NotFound";
import { NewsOrder } from "./NewsComponents";
import { Dialog, DialogTitle, DialogContent, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';




export default function NewsComponent({ itemsPerPage, items }) {
    const [orderedItems, setOrderedItems] = useState([])
    const [paginatedItems, setPaginatedItems] = useState([])
    const { t } = useTranslation()

    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <>
            {!items.length ? <NotFound /> :
                <div className="container-fluid">
                    <div className="row">


                        <NewsOrder items={items} setOrderedItems={setOrderedItems} />

                        {paginatedItems.map((actualite, index) => {
                            return (
                                <div key={index} style={{ cursor: 'pointer' }} className="card col-md-4 shadow-lg" >
                                    <div onClick={handleClickOpen} className="card-body">
                                        <div className="featured-imagebox featured-imagebox-post style2">
                                            <div className="featured-imagebox-post-inner">
                                                <div className="featured-thumbnail">
                                                    <img className="img-fluid" src={`${Global.backend}/uploads/${actualite.image}`} alt="blog-image" />
                                                </div>
                                                <div className="featured-content" style={{padding:"1rem"}}>
                                                    <div className="featured-title">
                                                        <h3 style={{ margin: 0 }}>{actualite.titre}</h3>
                                                        <p >{formatDate(actualite.createdAt)}</p>
                                                    </div>
                                                    <div className="featured-desc">
                                                        <p style={{
                                                            display: '-webkit-box',
                                                            WebkitLineClamp: 3, 
                                                            WebkitBoxOrient: 'vertical',
                                                            overflow: 'hidden',
                                                            textOverflow: 'ellipsis',
                                                            margin:0
                                                        }}>{actualite.description}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md">
                                        <DialogTitle>{actualite.titre}</DialogTitle>
                                        <IconButton
                                            aria-label="close"
                                            onClick={handleClose}
                                            sx={{
                                                position: 'absolute',
                                                right: 8,
                                                top: 8,
                                            }}
                                        >
                                            <CloseIcon />
                                        </IconButton>
                                        <DialogContent dividers>
                                            <img className="img-fluid d-flex" src={`${Global.backend}/uploads/${actualite.image}`} alt="blog-image" style={{ width: '70%', marginBottom: '20px', marginLeft: "auto", marginRight: "auto" }} />
                                            <Typography variant="body1" gutterBottom>
                                                {actualite.description}
                                            </Typography>
                                            <Typography variant="body2" color="textSecondary">
                                                {actualite.additionalDetails}
                                            </Typography>
                                        </DialogContent>
                                    </Dialog>
                                </div>
                            )
                        })}

                    </div>



                    <Pagination itemsPerPage={itemsPerPage} items={orderedItems} setItems={setPaginatedItems} />
                </div>
            }
        </>
    );
}














